import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { SidebarComponent } from './sidebar/sidebar.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    imports: [SidebarComponent, CdkScrollable, RouterOutlet]
})
export class MainComponent {
}
